import { KawaseBlurFilter } from 'pixi-filters';
import { Config } from '../../video-data/config';
import { assertNumberBetween } from '../../validators';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';
import { observable, reaction } from '../reactivity';

/**
 * A simple Blur filter, applying a Gaussian blur to the asset.
 */
export class BlurFilter extends Filter {
    static readonly NEUTRAL_BLUR = 0;

    override _classType = Config.BLUR_FILTER;
    override pixiFilter: KawaseBlurFilter;
    @observable accessor #blur = BlurFilter.NEUTRAL_BLUR;

    constructor(settings: BaseSettings) {
        super(settings);
        const defaultBlur = 0;
        const defaultQuality = 15;
        const clampEdges = true;
        this.pixiFilter = new KawaseBlurFilter(defaultBlur, defaultQuality, clampEdges);

        this.addReaction(
            reaction(
                () => this.#blur,
                (blur) => {
                    this.pixiFilter.strength = blur;
                },
                { name: 'BlurFilter.blur' },
            ),
        );
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(['blur']);
    }

    get blur(): number {
        return this.#blur;
    }

    set blur(value: number) {
        if (value === this.#blur) {
            return;
        }
        assertNumberBetween(value, 0, 10);
        this.#blur = value;
        this.requiresUpdate = true;
    }

    override isNeutral(): boolean {
        return this.blur === BlurFilter.NEUTRAL_BLUR;
    }
}
